import s from './settings.module.scss'
import useMedia from 'use-media'
import { NavLink, useLocation } from 'react-router-dom';
import { IconChevronRight } from '@tabler/icons-react'
import { useProfile } from '@shared/api/useProfile'
import { PageTemplate } from '@shared/ui/page-template'
import { getFullName } from '@utils/lib/getFullname'
import { TimezoneButton } from '@features/profile/timezone'
import { VacationButton } from '@features/profile/vacation'
import { Tab, Tabs } from '@shared/ui/tabs/tabs'
import { SettingsForm } from '@pages/settings/settings-form/settings-form'
import { VideoSettings } from '@pages/settings/video-settings/video-settings'
import { Notifications } from '@pages/settings/notification-settings/notification'
import { UpdatePassword } from '@pages/settings/update-password/update-password'
import { AppearanceSettings } from '@pages/settings/appearance-settings'
import { auth } from '@shared/api/services'
import { SupportButton } from '@shared/ui/support-button';
import { version } from 'info';
import classNames from 'classnames';

export const TeacherSettings = () => {
	const isMobile = useMedia({maxWidth: '768px'})
	const {data: profile} = useProfile()
	const location = useLocation()

	const options = [
		{label: 'Профиль', value: 'profile'},
		{label: 'Видео и Аудио', value: 'video-and-audio'},
		{label: 'Уведомления', value: 'notifications'},
		{label: 'Безопасность', value: 'security'},
		{label: 'Внешний вид', value: 'appearance'},
	]

	return (
		<PageTemplate title='Настройки'>
			{isMobile ? <div className={s.menu}>
				<div className={s.profile}>
					<div className={s.avatar}>
						<img src={profile.avatar ? process.env.REACT_APP_STORAGE_URL + profile.avatar.image : process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'} alt="" />
					</div>
					<div className={s.profileContent}>
						<div className={s.mail}>Профиль</div>
						<div className={s.name}>{getFullName(profile)}</div>
					</div>
				</div>
				<div className={s.menuList}>
					<div className={s.menuOption}>
						<TimezoneButton/>
					</div>
					<div className={s.menuDivider}/>
					<div className={s.menuOption}>
						<VacationButton/>
					</div>
				</div>
				<div className={s.menuList}>
					<NavLink className={s.menuItem} to="./profile">Профиль<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./video-and-audio">Видео и аудио<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./notifications">Уведомления<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./security">Безопасность<IconChevronRight size={16} color='#888'/></NavLink>
				<NavLink className={s.menuItem} to="./appearance">Внешний вид<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="/info">Информация<IconChevronRight size={16} color='#888'/></NavLink>
				</div>
				<div className={s.menuList}>
					<SupportButton label="Написать в поддержку"
						// shape="pill"
						theme="secondary"
						buttonClassName={classNames(s.menuItem,s.supportButton)}/>
				</div>
				<div className={s.menuList}>
					<NavLink className={s.logout} onClick={() => auth.logout()}>Выйти</NavLink>
				</div>
				<div className={s.version}>Версия {version}</div>
			</div> : 
				<Tabs className={s.tabs} defaultTab={location?.state?.defaultTab ? options?.findIndex(_ => _.value === location?.state?.defaultTab) : null} options={options}>
					<Tab>
						<SettingsForm/>
					</Tab>
					<Tab>
						<VideoSettings />
					</Tab>
					<Tab>
						<Notifications/>
					</Tab>
					<Tab>
						<UpdatePassword/>
					</Tab>
					<Tab>
						<AppearanceSettings/>
					</Tab>
				</Tabs>
			}
		</PageTemplate>
	)
}